class MotionElement extends HTMLElement {
    constructor() {
        super()
    }

    connectedCallback() {
        // @ts-ignore
        window.matchMedia("(prefers-reduced-motion: reduce)").matches || (this.preInitialize(), MotionAnimation.inView(this, async () => {
            // @ts-ignore
            !this.isInstant && this.media && await this.imageReady(this.media), this.initialize()
        }, {
            margin: "0px 0px -50px 0px"
        }));
    }

    get isHold() {
        return this.hasAttribute("hold")
    }

    get isInstant() {
        return this.hasAttribute("data-instantly")
    }

    get mediaElements() {
        return Array.from(this.querySelectorAll("img, iframe, svg"))
    }

    get animationType() {
        return this.dataset.motion || "fade-up"
    }
    
    get animationDelay() {
        // @ts-ignore
        return parseInt(this.dataset.motionDelay || 0) / 1000
    }

    // @ts-ignore
    imageReady(imageOrArray) {
        if (!imageOrArray) {
            return Promise.resolve();
        }

        // Ensure imageOrArray is an array of elements
        const images = imageOrArray instanceof Element
            ? [imageOrArray]
            : Array.from(imageOrArray);

        // Wait for all images to be loaded or invisible
        return Promise.all(
            images.map(image => {
            return new Promise(resolve => {
                const isImage = image.tagName === "IMG";
                const isLoaded = image.complete;
                const isVisible = !!image.offsetParent;

                if ((isImage && isLoaded) || !isVisible) {
                    // @ts-ignore
                    resolve();
                } else {
                    // @ts-ignore
                    image.onload = () => resolve();
                }
            });
            })
        );
    }

    preInitialize() {
        if (!this.isHold) 
            switch (this.animationType) {
            case "fade-in":
                // @ts-ignore
                MotionAnimation.animate(this, {
                    opacity: .01
                }, {
                    duration: 0
                });
                break;
            case "fade-up":
                // @ts-ignore
                MotionAnimation.animate(this, {
                    transform: "translateY(2.5rem)",
                    opacity: .01
                }, {
                    duration: 0
                });
                break;
            case "zoom-in":
                // @ts-ignore
                MotionAnimation.animate(this, {
                    transform: "scale(0.8)"
                }, {
                    duration: 0
                });
                break;
            case "zoom-in-lg":
                // @ts-ignore
                MotionAnimation.animate(this, {
                    transform: "scale(0)"
                }, {
                    duration: 0
                });
                break;
            case "zoom-out":
                // @ts-ignore
                MotionAnimation.animate(this, {
                    transform: "scale(1.3)"
                }, {
                    duration: 0
                });
                break;
            case "zoom-out-sm":
                // @ts-ignore
                MotionAnimation.animate(this, {
                    transform: "scale(1.1)"
                }, {
                    duration: 0
                })
        }
    }
    async initialize() {
        if (!this.isHold) 
            switch (this.animationType) {
            case "fade-in":
                // @ts-ignore
                await MotionAnimation.animate(this, {
                    opacity: 1
                }, {
                    duration: 1.5,
                    delay: this.animationDelay,
                    easing: [0, 0, .3, 1]
                }).finished;
                break;
            case "fade-up":
                // @ts-ignore
                await MotionAnimation.animate(this, {
                    transform: "translateY(0)",
                    opacity: 1
                }, {
                    duration: .5,
                    delay: this.animationDelay,
                    easing: [0, 0, .3, 1]
                }).finished;
                break;
            case "zoom-in":
                // @ts-ignore
                await MotionAnimation.animate(this, {
                    transform: "scale(1)"
                }, {
                    duration: 1.3,
                    delay: this.animationDelay,
                    easing: [0, 0, .3, 1]
                }).finished;
                break;
            case "zoom-in-lg":
                // @ts-ignore
                await MotionAnimation.animate(this, {
                    transform: "scale(1)"
                }, {
                    duration: .5,
                    delay: this.animationDelay,
                    easing: [0, 0, .3, 1]
                }).finished;
                break;
            case "zoom-out":
                // @ts-ignore
                await MotionAnimation.animate(this, {
                    transform: "scale(1)"
                }, {
                    duration: 1.5,
                    delay: this.animationDelay,
                    easing: [0, 0, .3, 1]
                }).finished;
                break;
            case "zoom-out-sm":
                // @ts-ignore
                await MotionAnimation.animate(this, {
                    transform: "scale(1)"
                }, {
                    duration: 1,
                    delay: this.animationDelay,
                    easing: [0, 0, .3, 1]
                }).finished;
                break
        }
    }
    // @ts-ignore
    async resetAnimation(duration) {
        switch (this.animationType) {
            case "fade-in":
                // @ts-ignore
                await MotionAnimation.animate(this, {
                    opacity: 0
                }, {
                    duration: duration || 1.5,
                    delay: this.animationDelay,
                    easing: duration ? "none" : [0, 0, .3, 1]
                }).finished;
                break;
            case "fade-up":
                // @ts-ignore
                await MotionAnimation.animate(this, {
                    transform: "translateY(2.5rem)",
                    opacity: 0
                }, {
                    duration: duration || .5,
                    delay: this.animationDelay,
                    easing: duration ? "none" : [0, 0, .3, 1]
                }).finished;
                break;
            case "zoom-in":
                // @ts-ignore
                await MotionAnimation.animate(this, {
                    transform: "scale(0)"
                }, {
                    duration: duration || 1.3,
                    delay: this.animationDelay,
                    easing: duration ? "none" : [0, 0, .3, 1]
                }).finished;
                break;
            case "zoom-in-lg":
                // @ts-ignore
                await MotionAnimation.animate(this, {
                    transform: "scale(0)"
                }, {
                    duration: duration || 1.3,
                    delay: this.animationDelay,
                    easing: duration ? "none" : [0, 0, .3, 1]
                }).finished;
                break;
            case "zoom-out":
                // @ts-ignore
                await MotionAnimation.animate(this, {
                    transform: "scale(0)"
                }, {
                    duration: duration || 1.3,
                    delay: this.animationDelay,
                    easing: duration ? "none" : [.16, 1, .3, 1]
                }).finished;
                break;
            case "zoom-out-sm":
                // @ts-ignore
                await MotionAnimation.animate(this, {
                    transform: "scale(0)"
                }, {
                    duration: duration || 1.3,
                    delay: this.animationDelay,
                    easing: duration ? "none" : [.16, 1, .3, 1]
                }).finished;
                break
        }
    }
    refreshAnimation() {
        this.removeAttribute("hold"), this.preInitialize(), setTimeout(() => {
            this.initialize()
        }, 50);
    }
}
customElements.define("motion-element", MotionElement);
